import { WithLocale } from '@/types/platform-data';

export enum HeaderPopupKeys {
    auth = 'auth',
    navbar = 'navbar',
}

export interface HeaderProps extends WithLocale {
    onOpen: (key: HeaderPopupKeys) => void;
    onClose: (key: HeaderPopupKeys) => void;
    isVisible: { [key: string]: boolean };
    isCalendar?: boolean;
}
